import record_selected from "../img/record_selected_64.png";
import authoring_selected from "../img/authoring_selected_64.png";
import read_aloud_selected from "../img/read_aloud_selected_64.png";
import word_clarification_selected from "../img/word_clarification_selected_64.png";
import word_wall_selected from "../img/word_wall_selected_64.png";

import reflection_selected from "../img/strategies_icons/reflection.png";

export const taskRegistry = {
    record: {
        label: "Aufnehmen",
        icon: record_selected,
        type: "task",
    
        descriptions: [
          {
            id: "record_reading",
            label: "Lesung aufnehmen",
            text: "Lies deinen Abschnitt laut vor und nimm dich dabei auf. Höre dir die Aufnahme danach noch einmal an."
          },
          {
            id: "record_fluency",
            label: "Leseflüssigkeit üben",
            text: "Nimm deine Lesung auf und achte auf Tempo, Genauigkeit und Betonung."
          },
          {
            id: "record_improve",
            label: "Lesung verbessern",
            text: "Nimm deine Lesung auf, übe deinen Text noch einmal und nimm ihn dann erneut auf."
          },








          {
            id: "read_record",
            label: "Lesen und Aufnehmen",
            text: "Lies deinen Abschnitt laut vor und nimm dabei deine Rolle auf."
          },
        ]
      },
    
      feedback: {
        label: "Feedback geben",
        iconFallback: "✏",
        type: "task",
    
        descriptions: [
          {
            id: "feedback_peer",
            label: "Peer-Feedback geben",
            text: "Höre oder schaue dir die Arbeit einer anderen Gruppe an und gib hilfreiches Feedback."
          },
          {
            id: "feedback_reading",
            label: "Feedback zur Lesung",
            text: "Achte beim Zuhören auf Tempo, Genauigkeit und Ausdruck und gib deiner Gruppe Rückmeldung."
          },
          {
            id: "feedback_improvement",
            label: "Verbesserungsvorschläge machen",
            text: "Überlege, was besonders gut gelungen ist und was noch verbessert werden kann."
          },






          {
            id: "fluency_improve",
            label: "Leseflüssigkeit verbessern",
            text: "1. Höre deine Aufnahme an.\n" +
                  "2. Prüfe dein Lesen mit der Checkliste (z. B. Tempo, Genauigkeit, Betonung).\n" +
                  "3. Lies deinen Text erneut und nimm ihn wieder auf.\n" +
                  "4. Achte darauf, dein Lesen zu verbessern."
          }
        ]
      },
    
      analyze: {
        label: "Wortwolke",
        icon: word_wall_selected,
        type: "task",
    
        descriptions: [
          {
            id: "analyze_unknown",
            label: "Unbekannte Wörter finden",
            text: "Schicke Wörter, die du nicht kennst, in die Wortwolke."
          },







          {
            id: "analyze_verbs",
            label: "Verben sammeln",
            text: "Schicke alle Verben aus dem Text in die Wortwolke."
          },
          {
            id: "analyze_adjectives",
            label: "Adjektive sammeln",
            text: "Schicke alle Adjektive aus dem Text in die Wortwolke."
          },
          {
            id: "analyze_pronunciation",
            label: "Schwierige Wörter",
            text: "Schicke Wörter, die du schwer aussprechen kannst, in die Wortwolke."
          },{
            id: "analyze_nomen",
            label: "Schwierige Wörter",
            text: "Schicke Wörter, die du schwer aussprechen kannst, in die Wortwolke."
          }
        ]
      },
    
      enrichments: {
        label: "Gestalten",
        icon: authoring_selected,
        type: "task",
    
        descriptions: [
          {
            id: "enrich_one",
            label: "Ein Bild gestalten",
            text: "Gestalte ein Bild zu deiner Rolle in der Geschichte."
          },
          {
            id: "enrich_multiple",
            label: "Mehrere Bilder gestalten",
            text: "Gestalte zwei bis drei Bilder zu deiner Rolle in der Geschichte."
          },
          {
            id: "enrich_per_textbox",
            label: "Bilder zu jedem Abschnitt",
            text: "Gestalte zu jedem Textabschnitt deiner Rolle ein eigenes Bild."
          },
          {
            id: "enrich_improve",
            label: "Illustrationen verbessern",
            text: "Überarbeite deine Bilder mithilfe des Feedbacks deiner Mitschülerinnen und Mitschüler."
          },
          {
            id: "read_enrich_present_improve",
            label: "Gestalten",
            text: "1. Lies deine Rolle in der Gruppe laut vor.\n" +
                  "2. Wähle zwei Textboxen aus deiner Rolle und gestalte zu jedem Abschnitt ein passendes Bild.\n" +
                  "3. Lies deine Rolle vor und zeige deine Bilder an den passenden Stellen.\n" +
                  "  Prüft gemeinsam:\n" +
                  "   - Passen die Bilder zu den Textabschnitten?\n" +
                  "   - Folgen die Bilder logisch aufeinander?\n" +
                  "4. Verbessere deine Bilder."
          },


/* 

          {
            id: "read_roles_group",
            label: "Rollen gemeinsam lesen",
            text: "Lies deine Rolle in deiner Gruppe und trage deine Textstellen nacheinander laut vor."
          },
          {
            id: "enrich_two_textboxes",
            label: "Bilder zu zwei Textboxen",
            text: "Wähle zwei Textboxen aus deiner Rolle und gestalte zu jedem Textboxe ein passendes Bild."
          },          
          {
            id: "enrich_present_check_feedback",
            label: "Bilder prüfen und Feedback",
            text: "Lies mit deiner Gruppe die Fabel vor und zeige deine Bilder an den passenden Stellen. Überprüft gemeinsam:\n- Passen die Bilder zur Geschichte?\n- Sind die Bilder in der richtigen Reihenfolge?\nGebt euch anschließend gegenseitig Feedback (Rückmeldungen)."
          },
          {
            id: "enrich_feedback_improve",
            label: "Feedback nutzen und verbessern",
            text: "Erhaltet Feedback (Rückmeldungen) von euren Mitschülern und verbessert anschließend eure Bilder."
          }, */

          
        ]
      },
    
      hexiLexi: {
        label: "HexiLexi",
        icon: word_clarification_selected,
        type: "task",
    
        descriptions: [
          {
            id: "hexi_vocab",
            label: "Neue Wörter klären",
            text: "Versuche zuerst, die Bedeutung unbekannter Wörter aus dem Textzusammenhang zu erschließen. Wenn das nicht möglich ist, nutze HexiLexi (Lexikon)."
          },



          {
            id: "hexi_context",
            label: "Wörter im Kontext verstehen",
            text: "Untersuche schwierige Wörter aus dem Text und versuche ihre Bedeutung im Kontext zu verstehen."
          },
          {
            id: "hexi_collect",
            label: "Wortschatz sammeln",
            text: "Sammle neue Wörter aus deinem Abschnitt und notiere ihre Bedeutung."
          }
        ]
      },
    
      volesen: {
        label: "Vorlesen",
        icon: read_aloud_selected,
        type: "task",
    
        descriptions: [
          {
            id: "read_role",
            label: "Rolle vorlesen",
            text: "Lies deine Rolle laut und deutlich vor."
          },
          {
            id: "read_expression",
            label: "Ausdrucksvoll lesen",
            text: "Lies deinen Abschnitt mit passendem Tempo und Ausdruck."
          },
          {
            id: "read_theatre",
            label: "Readers Theater",
            text: "Lies deine Rolle so vor, dass das Publikum die Geschichte gut verstehen kann."
          },
          {
            id: "read_together",
            label: "Gemeinsam lesen",
            text: "Lest die Geschichte gemeinsam in der Klasse, sodass alle Rollen zusammenkommen."
          },



          {
            id: "listen_understand",
            label: "Zuhören und Verstehen der Fabel",
            text: "Höre der Fabel aufmerksam zu und verstehe die Geschichte und ihre Moral."
          },



/* 

          {
            id: "read_theatre_probe",
            label: "Probe-Durchgang Lesetheater",
            text: "Lies deine Rolle im Probe-Durchgang des Lesetheaters. Übe deinen Ausdruck und zeige deine Bilder an den passenden Textstellen. Prüfe gemeinsam mit deiner Gruppe, ob alles zusammenpasst."
          },
          {
            id: "read_theatre_final",
            label: "Lesetheater Aufführung",
            text: "Führe dein Lesetheater auf. Lies deine Rolle flüssig und ausdrucksstark und zeige deine Bilder an den passenden Stellen, damit das Publikum die Geschichte gut versteht."
          }
 */

          {
            id: "read_theatre_probe_final",
            label: "Lesetheater Probe und Aufführung",
            text:
            "Führe dein Lesetheater in zwei Schritten durch:\n" +
            "1. Probe:\n" +
            "Übe deine Rolle und deinen Ausdruck. Zeige deine Bilder an passenden Stellen.\n" +
            "2. Aufführung:\n" +
            "Führe dein Lesetheater flüssig und ausdrucksstark vor."
          }



        ]
      },
      sammeln_single_user: {
        label: "Sammeln",
        icon: read_aloud_selected,
        type: "task",
    
        descriptions: [
          {
            id: "mark_unknown_words",
            label: "Unbekannte Wörter klären",
            text: "Markiere unbekannte Wörter im Text und sammle sie in der Wortwolke."
          },
          {
            id: "mark_verbs",
            label: "Verben markieren",
            text: "Markiere Verben im Text und sammle sie in der Wortwolke."
          },  
          {
            id: "mark_normen",
            label: "Normen markieren",
            text: "Markiere Normen im Text und sammle sie in der Wortwolke."
          },        
          {
            id: "mark_prefixes",
            label: "ge- und ver- markieren",
            text: "Markiere ge- und ver- Wörter im Text und sammle sie in der Wortwolke."
          },
        ]
      },

  nachdenken: {
    label: "Nachdenken",
    icon: reflection_selected,
    type: "reflection_container"
  },

  reflection_1: {
    label: "Reflexion zum Verstehen der Fabel",
    icon: reflection_selected,
    type: "reflection_container",
  },
  reflection_5: {
    label: "Reflexion zum Gestalten",
    icon: reflection_selected,
    type: "reflection_container",
  },
  
  reflection_6: {
    label: "Reflexion zum Lesefluessigkeit und Lesetheater",
    icon: reflection_selected,
    type: "reflection_container",
  },
  
};